// Rotation in degrees.
export type Rotation = 0|90|180|270|360|- 80|- 180|- 270;
